import { defineComponent as _defineComponent } from 'vue'
import AiMyprCompanyUrlField from '@/components/yagiprime/AiMyprCompanyUrlField.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'ReasonAiMyprForm',
  props: {
    formatData: null,
    hopeIndustryOptions: null,
    hopeJobcategoryOptions: null,
    isYagiPrime: { type: Boolean },
    extracting: { type: Boolean },
    extracted: { type: Boolean },
    licences: null,
    layout: null
  },
  emits: ["update-field", "extract", "prime-cta"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'update-field', payload: { key: string; value: unknown }): void
  (e: 'extract'): void
  (e: 'prime-cta'): void
}), expose: any, slots: any, attrs: any }) {





function emitUpdate(key: string, value: unknown) {
  emit('update-field', { key, value })
}

function onSelectChange(key: string, event: Event) {
  const target = event.target
  if (!(target instanceof HTMLSelectElement)) return
  emitUpdate(key, target.value)
}

return { __sfc: true,emit, emitUpdate, onSelectChange, AiMyprCompanyUrlField }
}

})